<ng-container *ngIf="isAuthAccessibilityEnabled; else legacyCheckboxTpl">
<div
  *ngIf="type === 'check'"
  class="custom-control custom-checkbox custom-checkbox-new custom-checkbox-un-01"
  [formGroup]="form"
>
  <input
    type="checkbox"
    class="custom-control-input"
    [id]="'checkbox-' + controlName + random"
    [formControlName]="controlName"
    [attr.checked]="form.controls?.[controlName]?.value ? true: null"
    [attr.disabled]="disabled ? true : null"
    [attr.aria-label]="ariaLabel || label || null"
    [attr.aria-describedby]="getAriaDescribedby()"
    [attr.aria-required]="isRequired ? 'true' : null"
    [attr.aria-invalid]="control?.dirty && control?.errors ? 'true' : null"
  />
  <label *ngIf="!IsFormFieldNameHidden"
    class="custom-control-label custom-checkbox-label d-flex"
    [for]="'checkbox-' + controlName + random"
    [ngClass]="{ disabled: disabled ? true : false }"
    ><span [ngClass]="{ disabled: disabled ? true : false }">
      <div style="display: flex">
        <span *ngIf="IsFromForm && IsInfoVisible && infoText" class="ng-binding d-flex align-items-center">
            <i class="icon-info" *ngIf="!DisplayOnScreen" [title]="infoText"></i>
        </span>
        <span *ngIf="!IsFromForm && infoText">
          <i class="icon-info" [title]="infoText"></i>
        </span>
        <div>
          <span [ngClass]="IsFromForm ? 'field-title':''">{{ label }}</span>
          <span *ngIf="IsFromForm && IsInfoVisible && infoText && DisplayOnScreen" (click)="$event.stopPropagation()">
            <br>
            <i [ngClass]="isTextVisible ? 'icon-chv-down' : 'icon-chv-up'" class="toggle-icon" title="Toggle Text"
              *ngIf="AllowMinimize" (click)="toggleText($event)" (keydown)="$event.preventDefault()"></i>
            <span [class.hidden-text]="!isTextVisible" class="info-text">
              {{ infoText }}
            </span>
          </span>
        </div>
      </div>
    </span>
    <span *ngIf="label && (control?.hasValidator(validator) || control?.errors?.required) && !control?.value && !(disabled || control?.disabled || isHeader)" class="text-danger ml-1" aria-hidden="true">*</span>
  </label>
  <div
    *ngIf="control?.dirty && control?.errors"
    class="info-box error-box"
    [id]="'checkbox-' + controlName + random + '-error'"
    role="alert"
    aria-live="polite"
  >
    <span class="text-danger"> {{ errorMessagePrefix + getErrorMessage() }} </span>
  </div>
</div>

<div *ngIf="type === 'toggle' && form" class="form-group" [formGroup]="form">
  <div class="switch-slider focus-none">
    <div style="display: flex" class="col-md-6 p-0" [ngClass]="(label || infoText) ? '':'d-none'">
      <span *ngIf="IsFromForm && IsInfoVisible && infoText" class="ng-binding d-flex align-items-center">
          <i class="icon-info" *ngIf="!DisplayOnScreen" [title]="infoText"></i>
      </span>
      <span *ngIf="!IsFromForm && infoText">
        <i class="icon-info" [title]="infoText"></i>
      </span>
      <div *ngIf="label" [ngClass]="{ 'custom-edit-icon' : showEditIcon && showPlugIcon , 'custom-display': showPlugIcon}">
        <span class="text ml-0">{{ label }}</span>
        <span *ngIf="IsFromForm && IsInfoVisible && infoText && DisplayOnScreen" (click)="$event.stopPropagation()">
          <br>
          <i [ngClass]="isTextVisible ? 'icon-chv-down' : 'icon-chv-up'" class="toggle-icon" title="Toggle Text"
            *ngIf="AllowMinimize" (click)="toggleText($event)" (keydown)="$event.preventDefault()"></i>
          <span [class.hidden-text]="!isTextVisible">
            {{ infoText }}
          </span>
        </span>
        <i *ngIf="showPlugIcon" style="font-size:20px" class="icon-plug"></i>
      </div>
      <a *ngIf="showEditIcon" class="btn btn-edit-action mr-10" (click)="editClicked.emit()">
        <i class="icon-edit"></i>
      </a>
    </div>

    <div class="col-md-6">
      <input
        type="checkbox"
        class="toggle"
        [id]="'checkbox-' + controlName + random"
        [formControlName]="controlName"
        [attr.checked]="form.controls?.[controlName]?.value ? true: null"
        [attr.disabled]="disabled ? true : null"
        [attr.aria-label]="ariaLabel || label || null"
        [attr.aria-describedby]="getAriaDescribedby()"
        [attr.aria-required]="isRequired ? 'true' : null"
      />
      <label [for]="'checkbox-' + controlName + random">
        <span class="on">ON</span>
        <span class="off">OFF</span>
      </label>
    </div>
  </div>
</div>

<div *ngIf="type === 'toggle' && !form" class="form-group">
  <div class="switch-slider focus-none">
    <div *ngIf="label" class="col-md-6">
      <span class="text ml-0">{{ label }}</span>
    </div>
    <div class="col-md-6">
      <input
        type="checkbox"
        class="toggle"
        [checked]="checked"
        [id]="'checkbox-' + random"
        [attr.checked]="checked ? true: null"
        [attr.disabled]="disabled ? true : null"
        [attr.aria-label]="ariaLabel || label || null"
        [attr.aria-describedby]="getAriaDescribedby()"
      />
      <label [for]="'checkbox-' + random">
        <span class="on">ON</span>
        <span class="off">OFF</span>
      </label>
    </div>
  </div>
</div>
</ng-container>

<ng-template #legacyCheckboxTpl>
<div
  *ngIf="type === 'check'"
  class="custom-control custom-checkbox custom-checkbox-new custom-checkbox-un-01"
  [formGroup]="form"
>
  <input
    type="checkbox"
    class="custom-control-input"
    [id]="'checkbox-' + controlName + random"
    [formControlName]="controlName"
    [attr.checked]="form.controls?.[controlName]?.value ? true: null"
    [attr.disabled]="disabled ? true : null"
    [attr.aria-label]="ariaLabel || label || null"
    [attr.aria-required]="isRequired ? 'true' : null"
    [attr.aria-invalid]="control?.dirty && control?.errors ? 'true' : null"
    [attr.aria-describedby]="getAriaDescribedby()"
  />
  <label *ngIf="!IsFormFieldNameHidden"
    class="custom-control-label custom-checkbox-label d-flex"
    [for]="'checkbox-' + controlName + random"
    [ngClass]="{ disabled: disabled ? true : false }"
    ><span [ngClass]="{ disabled: disabled ? true : false }">
      <div style="display: flex">
        <span *ngIf="IsFromForm && IsInfoVisible && infoText" class="ng-binding d-flex align-items-center">
            <i class="icon-info" *ngIf="!DisplayOnScreen" [title]="infoText"></i>
        </span>
        <span *ngIf="!IsFromForm && infoText">
          <i class="icon-info" [title]="infoText"></i>
        </span>
        <div>
          <span [ngClass]="IsFromForm ? 'field-title':''">{{ label }}</span>
          <span *ngIf="IsFromForm && IsInfoVisible && infoText && DisplayOnScreen" (click)="$event.stopPropagation()">
            <br>
            <i [ngClass]="isTextVisible ? 'icon-chv-down' : 'icon-chv-up'" class="toggle-icon" title="Toggle Text"
              *ngIf="AllowMinimize" (click)="toggleText($event)" (keydown)="$event.preventDefault()"></i>
            <span [class.hidden-text]="!isTextVisible" class="info-text">
              {{ infoText }}
            </span>
          </span>
        </div>
      </div>
    </span>
    <span *ngIf="label && (control?.hasValidator(validator) || control?.errors?.required) && !control?.value && !(disabled || control?.disabled || isHeader)" class="text-danger ml-1" aria-hidden="true">*</span>
  </label>
  <div
    *ngIf="control?.dirty && control?.errors"
    class="info-box error-box"
    [id]="'checkbox-' + controlName + random + '-error'"
    role="alert"
    aria-live="polite"
  >
    <span class="text-danger"> {{ errorMessagePrefix + getErrorMessage() }} </span>
  </div>
</div>

<div *ngIf="type === 'toggle' && form" class="form-group" [formGroup]="form">
  <div class="switch-slider focus-none">
    <div style="display: flex" class="col-md-6 p-0" [ngClass]="(label || infoText) ? '':'d-none'">
      <span *ngIf="IsFromForm && IsInfoVisible && infoText" class="ng-binding d-flex align-items-center">
          <i class="icon-info" *ngIf="!DisplayOnScreen" [title]="infoText"></i>
      </span>
      <span *ngIf="!IsFromForm && infoText">
        <i class="icon-info" [title]="infoText"></i>
      </span>
      <div *ngIf="label" [ngClass]="{ 'custom-edit-icon' : showEditIcon && showPlugIcon , 'custom-display': showPlugIcon}">
        <span class="text ml-0">{{ label }}</span>
        <span *ngIf="IsFromForm && IsInfoVisible && infoText && DisplayOnScreen" (click)="$event.stopPropagation()">
          <br>
          <i [ngClass]="isTextVisible ? 'icon-chv-down' : 'icon-chv-up'" class="toggle-icon" title="Toggle Text"
            *ngIf="AllowMinimize" (click)="toggleText($event)" (keydown)="$event.preventDefault()"></i>
          <span [class.hidden-text]="!isTextVisible">
            {{ infoText }}
          </span>
        </span>
        <i *ngIf="showPlugIcon" style="font-size:20px" class="icon-plug"></i>
      </div>
      <a *ngIf="showEditIcon" class="btn btn-edit-action mr-10" (click)="editClicked.emit()">
        <i class="icon-edit"></i>
      </a>
    </div>

    <div class="col-md-6">
      <input
        type="checkbox"
        class="toggle"
        [id]="'checkbox-' + controlName + random"
        [formControlName]="controlName"
        [attr.checked]="form.controls?.[controlName]?.value ? true: null"
        [attr.disabled]="disabled ? true : null"
        [attr.aria-required]="isRequired ? 'true' : null"
      />
      <label [for]="'checkbox-' + controlName + random">
        <span class="on">ON</span>
        <span class="off">OFF</span>
      </label>
    </div>
  </div>
</div>

<div *ngIf="type === 'toggle' && !form" class="form-group">
  <div class="switch-slider focus-none">
    <div *ngIf="label" class="col-md-6">
      <span class="text ml-0">{{ label }}</span>
    </div>
    <div class="col-md-6">
      <input
        type="checkbox"
        class="toggle"
        [checked]="checked"
        [id]="'checkbox-' + random"
        [attr.checked]="checked ? true: null"
        [attr.disabled]="disabled ? true : null"
      />
      <label [for]="'checkbox-' + random">
        <span class="on">ON</span>
        <span class="off">OFF</span>
      </label>
    </div>
  </div>
</div>
</ng-template>
